require('./').polyfill()



//////////////////
// WEBPACK FOOTER
// /home/travis/build/OffCourse/offcourse-next/node_modules/raf/polyfill.js
// module id = 492
// module chunks = 0